import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../mappers/learningflow.mapper";
import * as i2 from "../data.requirements";
export class GetLearningFlowUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run(id, skip, limit) {
        return this.data.getAllLearningFlow(id, skip, limit).pipe(this.mapper.map);
    }
}
GetLearningFlowUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetLearningFlowUseCase_Factory() { return new GetLearningFlowUseCase(i0.ɵɵinject(i1.LearningFlowMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: GetLearningFlowUseCase, providedIn: "root" });
